import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DoctorsContact from "../components/DoctorsContact";
import BannerDirectorio from "../components/BannerDirectorio";

export default function Directorio() {
  return (  
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
        <Header />
        <BannerDirectorio />
        <DoctorsContact />
        <Footer />
    </main>
    );
}